import React, { FC, useEffect } from "react";
import { HeaderContainer } from "../styles";
import {
  BlueButton,
  Button,
  CustomLabel,
  FlexContainer,
  OrangeButton,
} from "@mindmemobile/mm-shared-global";
import { theme } from "@mindmemobile/mm-shared-global";

type IProps = {
  showSaveButton: boolean;
  cancelClick: () => void;
  saveClick?: () => void;
  saveAndExitClick: () => void;
  saveAndExitButtonCaption: string | "SAVE & EXIT";
  headerCaption: string | "";
  cancelButtonCaption?: string | "";
  disableSaveButton?: boolean;
};

const Header: FC<IProps> = (props: IProps) => {
  useEffect(() => {
    const sendMessage = () => {
      const messagePayload = {
        type: "payment-header",
      };
      window.parent?.postMessage(JSON.stringify(messagePayload), "*");
    };
    sendMessage();
    return () => {};
  }, []);
  return (
    <HeaderContainer>
      <BlueButton primary onClick={() => props.cancelClick()}>
        {props.cancelButtonCaption || "CANCEL"}
      </BlueButton>
      <CustomLabel color={theme.palette.common.white}>
        {props.headerCaption}
      </CustomLabel>
      <div>
        <FlexContainer justifyContent="flex-end">
          {props.showSaveButton && (
            <Button
              onClick={() =>
                !props.disableSaveButton && props.saveClick && props.saveClick()
              }
              color="#fff"
              style={{
                cursor: props.disableSaveButton ? "not-allowed" : "pointer",
              }}
            >
              SAVE
            </Button>
          )}
          <OrangeButton primary onClick={() => props.saveAndExitClick()}>
            {props.saveAndExitButtonCaption}
          </OrangeButton>
        </FlexContainer>
      </div>
    </HeaderContainer>
  );
};

export default Header;
